// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q_OlM{padding:16px 0}.Q_OlM.FZ_H0{padding-top:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Q_OlM`,
	"containerWithCallout": `FZ_H0`
};
export default ___CSS_LOADER_EXPORT___;
